__turbopack_context__.v({
  "cancel-button": "Tooltip-module-scss-module__UMOVxG__cancel-button",
  "cancel-button-icon-wrapper": "Tooltip-module-scss-module__UMOVxG__cancel-button-icon-wrapper",
  "center": "Tooltip-module-scss-module__UMOVxG__center",
  "children-container": "Tooltip-module-scss-module__UMOVxG__children-container",
  "is-cancel-button-false": "Tooltip-module-scss-module__UMOVxG__is-cancel-button-false",
  "is-cancel-button-true": "Tooltip-module-scss-module__UMOVxG__is-cancel-button-true",
  "is-tooltip-above": "Tooltip-module-scss-module__UMOVxG__is-tooltip-above",
  "left": "Tooltip-module-scss-module__UMOVxG__left",
  "pointer": "Tooltip-module-scss-module__UMOVxG__pointer",
  "pointer-align-wrapper": "Tooltip-module-scss-module__UMOVxG__pointer-align-wrapper",
  "right": "Tooltip-module-scss-module__UMOVxG__right",
  "tooltip": "Tooltip-module-scss-module__UMOVxG__tooltip",
  "tooltip-container": "Tooltip-module-scss-module__UMOVxG__tooltip-container",
  "tooltip-wrapper": "Tooltip-module-scss-module__UMOVxG__tooltip-wrapper",
  "trigger-button-wrapper": "Tooltip-module-scss-module__UMOVxG__trigger-button-wrapper",
});
